<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">News</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <label for="newsId">ID </label>
          <input
            id="newsId"
            type="text"
            v-model="id"
            class="form-control"
            disabled
          />
        </div>
        <div class="col">
          <BrandDropdown
            v-model="brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"></BrandDropdown>
          <div v-if="isSubmit && $v.brandSelected.$invalid" class="text-error">
            กรุณาเลือกแบรนด์
          </div>
        </div>
        <div class="col">
          <label for="category">Category</label>
          <multiselect
            id="category"
            v-model="form.categorySelected"
            :options="categoryOptions"
            label="text"
            track-by="id">
          </multiselect>
          <div
            v-if="isSubmit && $v.form.categorySelected.$invalid"
            class="text-error">
            กรุณาเลือก Category
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col align-self-end">
          <label for="displayOrder">Display order </label>
          <NumberInput v-model="form.displayOrder" input-id="displayOrder" :is-decimal-allowed="false"/>
        </div>
        <div class="col">
          <label for="startPublishDate">Start publish date</label>
          <date-picker
            id="startPublishDate"
            v-bind="$attrs"
            v-model="form.startDate"
            format="D MMMM yyyy"
            lang="en"
            :value="form.startDate"
            @change="form.startDate = $event" />
          <div v-if="isSubmit && $v.form.startDate.$invalid" class="text-error">
            กรุณาเลือกวันที่เริ่มต้น
          </div>
        </div>
        <div class="col">
          <label for="endPublishDate">End publish date</label>
          <date-picker
            id="endPublishDate"
            v-bind="$attrs"
            v-model="form.endDate"
            format="D MMMM yyyy"
            lang="en"
            :value="form.endDate"
            @change="form.endDate = $event" />
          <div v-if="isSubmit && $v.form.endDate.$invalid" class="text-error">
            กรุณาเลือกวันที่สิ้นสุด
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label for="imageUpload">Image </label>
          <input
            id="imageUpload"
            type="file"
            @change="uploadImage"
            ref="file"
            class="form-control" />
        </div>
        <div id="col-6">
          <img
              id="preview"
              v-if="previewImage"
              :src="previewImage"
              alt="preview"
              style="max-width: 100%; height: auto; object-fit: contain;"
          />
        </div>
      </div>
      <div class="d-flex flex-row my-4">
        <input
          id="isHighlighted"
          class="form-check-input mr-2"
          type="checkbox"
          v-model="form.isHighlighted" />
        <label class="form-check-label" for="isHighlighted">
          Highlighted
        </label>
      </div>
      <div class="d-flex flex-row my-4">
        <input
          id="isPublished"
          class="form-check-input mr-2"
          type="checkbox"
          v-model="form.isPublished" />
        <label class="form-check-label" for="isPublished"> Published </label>
      </div>
      <div class="d-flex flex-row my-4">
        <input
          id="isShowAll"
          class="form-check-input mr-2"
          type="checkbox"
          v-model="form.isShowAll" />
        <label class="form-check-label" for="isShowAll">
          Show All Customers
        </label>
      </div>
      <div class="row">
        <div class="col align-self-end">
          <span>Title ({{ langSelect.text }})</span>
        </div>
        <div class="col-2 text-right">
          <multiselect
            v-model="langSelect"
            :options="[{ text: 'TH' }, { text: 'EN' }]"
            label="text"
            track-by="text">
          </multiselect>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input
            v-show="langSelect.text === 'TH'"
            type="text"
            v-model="form.titleTh"
            class="form-control" />
          <div
            v-if="
              isSubmit &&
              langSelect.text === 'TH' &&
              !$v.form.titleTh.checkValue
            "
            class="text-error">
            กรุณากรอก Title
          </div>
          <input
            v-show="langSelect.text === 'EN'"
            type="text"
            v-model="form.titleEn"
            class="form-control" />
          <div
            v-if="
              isSubmit &&
              langSelect.text === 'EN' &&
              !$v.form.titleEn.checkValue
            "
            class="text-error">
            กรุณากรอก Title
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label :for="'detail_' + langSelect.text"
            >Detail ({{ langSelect.text }})</label
          >
          <div v-show="langSelect.text === 'TH'">
            <CkEditor
              id="detail_TH"
              :value="form.detailTh"
              :isTh="true"
              @setContent="setContent"></CkEditor>
            <div
              v-if="
                isSubmit &&
                langSelect.text === 'TH' &&
                !$v.form.detailTh.checkValue
              "
              class="text-error">
              กรุณากรอก Detail
            </div>
          </div>
          <div v-show="langSelect.text === 'EN'">
            <CkEditor
              id="detail_EN"
              :value="form.detailEn"
              :isTh="false"
              @setContent="setContent"></CkEditor>
            <div
              v-if="
                isSubmit &&
                langSelect.text === 'EN' &&
                !$v.form.detailEn.checkValue
              "
              class="text-error">
              กรุณากรอก Detail
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <router-link
          :to="{ name: 'News' }"
          class="btn btn-outline-danger btn-cancel"
          >Cancel</router-link
        >
        <button class="btn btn-outline-success ml-10" @click="checkValidate">
          Save
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="text-center">
          <div v-if="showSuccess && id">
            <button class="btn-back" @click="bindingData()">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="mt-5">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'News' })">
              กลับสู่หน้าหลัก
            </button>
          </div>
          <button
            v-if="!showSuccess"
            class="btn-back"
            @click="showDialog = false">
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import NewsService from "services/api/news.service";
import CkEditor from "components/CkEditor/CkEditor";
import BrandDropdown from "components/Brand/BrandDropdown";
import NumberInput from "components/NumberInput/NumberInput.vue";
import ApiHandlerService from "services/api/apiHandler.service";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    NumberInput,
    CkEditor,
    BrandDropdown,
  },
  data() {
    let query = this.$route.query;
    const userId = query.id;
    return {
      message: "",
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      id: userId,
      langSelect: { text: "TH" },
      categoryOptions: [],
      brandSelected: null,
      form: {
        id: null,
        isPublished: true,
        isHighlighted: true,
        isShowAll: true,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        titleTh: null,
        detailTh: null,
        titleEn: null,
        detailEn: null,
        categorySelected: null,
        displayOrder: 0,
        thumbnailKey: null,
      },
      previewImage: null,
      isSubmit: false,
    };
  },
  validations: {
    form: {
      startDate: {
        required,
      },
      endDate: {
        required,
      },
      titleTh: {
        checkValue(_rule, value) {
          return !(this.langSelect.text === "TH" && !value.titleTh);
        },
      },
      detailTh: {
        checkValue(_rule, value) {
          return !(this.langSelect.text === "TH" && !value.detailTh);
        },
      },
      titleEn: {
        checkValue(_rule, value) {
          return !(this.langSelect.text === "EN" && !value.titleEn);
        },
      },
      detailEn: {
        checkValue(_rule, value) {
          return !(this.langSelect.text === "EN" && !value.detailEn);
        },
      },
      categorySelected: {
        required,
      },
    },
    brandSelected: {
      required,
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.getCategories();
    if (this.id) {
      await this.bindingData();
    }
    this.isLoading = false;
  },
  methods: {
    async addOrEditNews(body, isUpdate = false) {
      this.isLoading = true;
      try {
        await ApiHandlerService.handleResponse(
          NewsService.createOrUpdateNews(body, this.id, isUpdate),
          this
        );
      } catch (error) {
        ApiHandlerService.handleError(error, this);
      }
    },
    checkValidate() {
      this.isSubmit = true;
      const vm = this.$v.form;
      if (vm.$invalid) {
        return;
      } else if (
        !vm.titleTh.checkValue ||
        !vm.detailTh.checkValue ||
        !vm.titleEn.checkValue ||
        !vm.detailEn.checkValue
      ) {
        return;
      } else {
        this.onSubmit();
      }
    },
    onSubmit() {
      const form = this.form;
      this.showSuccess = false;
      const formData = new FormData();
      formData.append("publishedStatus", form.isPublished);
      formData.append(
        "startPublishedDate",
        moment(form.startDate).format("DD/MM/YYYY")
      );
      formData.append(
        "endPublishedDate",
        moment(form.endDate).format("DD/MM/YYYY")
      );
      formData.append("isShowAllCustomers", form.isShowAll);
      formData.append("titleTh", form.titleTh);
      formData.append("detailTh", form.detailTh);
      formData.append("titleEn", form.titleEn);
      formData.append("detailEn", form.detailEn);
      formData.append("brand", this.brandSelected.id);
      formData.append("category", form.categorySelected.id);
      formData.append("displayOrder", form.displayOrder);
      formData.append("isHighlighted", form.isHighlighted);
      if (form.thumbnailKey != null) {
        formData.append("thumbnailKey", form.thumbnailKey);
      }
      if (this.id) {
        this.addOrEditNews(formData, true);
      } else {
        this.addOrEditNews(formData);
      }
    },
    async bindingData() {
      this.isLoading = true;
      this.setDefault();
      try {
        await NewsService.getDetailNews(this.id)
          .then(async (res) => {
            this.isLoading = false;
            const data = await res.data.news;
            this.form = {
              id: data.id,
              isPublished: data.published,
              isHighlighted: data.isHighlighted,
              isShowAll: data.isShowAllCustomer,
              startDate: data.startPublishedDate,
              endDate: data.endPublishedDate,
              titleTh: data.titleTh,
              detailTh: data.detailTh,
              titleEn: data.titleEn,
              detailEn: data.detailEn,
              brandSelected: data.brandCode,
              categorySelected: this.categoryOptions.find(
                (s) => s.id === data.categoryName
              ),
              displayOrder: data.displayOrder ?? 0,
            };
            this.previewImage = data.image;
            this.setBrand(data.brandCode);
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async getCategories() {
      try {
        await NewsService.getListCategory()
          .then((res) => {
            const data = res.data;
            this.categoryOptions = data.categories.map((s) => {
              return {
                id: s,
                text: NewsService.formatNewsCategory(s),
              };
            });
            this.categoryOptions.sort(function (a, b) {
              return -(b - a);
            });
          })
          .catch((err) => {
            console.log("Error: ", err);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    uploadImage() {
      const imageFile = this.$refs.file.files[0];
      this.previewImage = URL.createObjectURL(imageFile);
      this.getPresignURL(imageFile);
    },
    async getPresignURL(file) {
      this.isLoading = true;
      await PresignedUploadUrlService.getS3SignUrl("news", file)
        .then((res) => {
          const data = res.data;
          this.form.thumbnailKey = data.key;
          this.updatePhotoToS3(data.presignedUrl, file);
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isLoading = false;
    },
    setContent(content, isTh = true) {
      if (isTh) {
        this.form.detailTh = content || "";
      } else {
        this.form.detailEn = content || "";
      }
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
    },
    setBrands(brands) {
      const listBrands = brands;
      listBrands
        .filter((f) => f.id === this.brandSelected)
        .map((brand) => {
          this.brandSelected = brand;
        });
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-title {
  font-weight: 900;
}

.btn {
  margin: 3rem 0;
}

.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}

.text-error {
  color: red;
  font-size: 12px;
}
.content-dialog {
  height: 300px;
  background: #fff;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}
.preview {
  #preview img {
    max-width: 300px;
    max-height: 300px;
  }
}
</style>
